import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetMeeting as GetMeetingQuery,
    GetMeetingVariables as GetMeetingQueryVariables,
} from 'nutshell-graphql-types';

import GET_MEETING from '../queries/get-meeting.graphql';

export const useGetMeeting = (id: string) => {
    const {data, error, loading, refetch} = useQuery<GetMeetingQuery, GetMeetingQueryVariables>(
        GET_MEETING,
        {
            variables: {id},
            fetchPolicy: 'cache-and-network',
        }
    );

    const meeting = data ? data.meeting : null;

    return {
        meeting,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        isLoading: loading,
        refetch,
    };
};
